export const defaultTemporaryOrderDomainState = {
    inProgressActions: new Map(),
    inProgressItems: [],
    payments: {
        currentRedirectPayment: undefined,
        maximumMemberBalancePayment: undefined
    }
};
